import { pathOr } from 'rambda';
import { left, right } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';
import { csosUpmApi, IError, ResponseCSOSHeaders } from '../common';
import { IStatusLegacies } from '.';

export const searchLegacyStatus =
  (hR: ResponseCSOSHeaders) =>
  ({
    page,
    pageSize,
    searchBy,
    searchP1,
    searchP2,
  }: {
    page: number;
    pageSize: number;
    searchBy: string;
    searchP1: string;
    searchP2: string;
  }) =>
    csosUpmApi(hR)
      .get(
        `v1/api/admin/legacy-requests?${getSearchBy({
          searchBy,
          searchP1,
        })}page=${page}&sizePerPage=${pageSize}&orderBy=ID&orderDirection=ASC${createdAt({
          searchBy,
          searchP1,
          searchP2,
        })}`
      )
      .then(
        flow(
          pathOr<IStatusLegacies>({ total: 0, content: [] }, 'data'),
          right
        )
      )
      .catch(e => left(e as IError));

/**
 * Maps UI searchBy values to backend query params
 */
const searchByMap: Record<string, string> = {
  id: 'id',
  // createdAt: 'createdAt',
  serialNumber: 'srNum',
  certificateEmail: 'certificateEmail',
  deaNumbers: 'deaNumber',
};

/**
 * Normal filter param
 */
const getSearchBy = ({
  searchBy,
  searchP1,
}: {
  searchBy: string;
  searchP1: string;
}) => {
  const key = pathOr<string | null>(null, searchBy, searchByMap);
  return key ? `${key}=${searchP1}&` : '';
};

/**
 * Date range filter
 */
const createdAt = ({
  searchBy,
  searchP1,
  searchP2,
}: {
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) =>
  (searchBy === 'createdAt' && searchP1 && searchP2)
    ? `&afterCreatedAtDate=${searchP1}&beforeCreatedAtDate=${searchP2}`
    : '&afterCreatedAtDate=2022-07-01&beforeCreatedAtDate=2032-07-01';
